import { FC } from 'react';
import {
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  Button,
} from '@chakra-ui/react';
import { editorTextSx } from 'app/chakra-theme/components/TextEditor';

export interface PlaylistAudioReadOnlyLyricsDialogProps {
  open: boolean;
  onClose: () => void;
  message?: string;
  subTitle?: string;
}

export const PlaylistAudioReadOnlyLyricsDialog: FC<PlaylistAudioReadOnlyLyricsDialogProps> = ({
  open,
  onClose,
  message = '',
  subTitle,
}) => {
  const title = 'Lyrics';
  const isEmpty = !message || message === '<p></p>';
  return (
    <Modal isOpen={open} onClose={onClose} data-testid="dialog" size="md">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader data-testid="dialog-title" title={title}>
          {title}
          {subTitle && (
            <Text
              color="textSubdued"
              textOverflow="ellipsis"
              overflow="hidden"
              title={subTitle}
            >
              {subTitle}
            </Text>
          )}
        </ModalHeader>
        <ModalBody
          data-testid="dialog-content"
          maxHeight="300px"
          overflowY="auto"
        >
          {isEmpty ? (
            <Text color="textSubdued" textAlign="center">
              {`This song doesn't have any lyrics yet.`}
            </Text>
          ) : (
            <Text
              sx={editorTextSx}
              dangerouslySetInnerHTML={{
                __html: message.replaceAll('<p></p>', '</br>'),
              }}
            />
          )}
        </ModalBody>
        <ModalFooter data-testid="dialog-actions">
          <Button onClick={onClose}>Done</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
